import styled from 'styled-components'
const Container = styled.div`
    .select-operator {
        width: 100%;
        margin-top: .3rem;
        &_container{
          > div {
            display: flex;
            flex-wrap: wrap;
            padding: -5px;
            > div{
                background-color: ${({theme}) => theme.secondary};
                color: ${({theme}) => theme.bg};
                border-radius: 5px;
                margin: 5px;
            }
          }
        }
    }
`

export {Container}